import { Controller, useForm } from "react-hook-form";
import { StyledDialog } from "../StyledComponents/Dialog/Dialog";
import {
  Box,
  DialogContent,
} from "@mui/material";
import {
  BodyMedium,
  H6HeadlineSmall,
} from "../StyledComponents/Typography/Typography.tsx";
import {
  StyledIconButton,
} from "../StyledComponents/Buttons/AuradineButtons.js";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth0 } from "@auth0/auth0-react";
import { StyledDataGrid } from "../StyledComponents/DataGrid/StyledDataGrid.tsx";
import useAppContextProvider from "../../AppContext/useAppContextProvider.js";
import { useTheme } from "../../ThemeContext/ThemeContext.js";

const OperationLogsHeader = ({ setOpen }) => {
  const { colors } = useTheme();
  return (
    <Box
      display={"flex"}
      flexDirection={"row"}
      justifyContent={"space-between"}
      flexGrow={1}
      padding={"1.5rem 0"}
    >
      <Box
        display={"flex"}
        flexDirection={"column"}
        gap={2}
      >
        <H6HeadlineSmall>
          {"Operation logs"}
        </H6HeadlineSmall>

        <BodyMedium>
          Use this window to view the operation logs.
        </BodyMedium>
      </Box>

      <StyledIconButton colors={colors}
        onClick={() => {
          setOpen(false);
        }}
      >
        <CloseIcon />
      </StyledIconButton>
    </Box>
  );
};

const OperationLogsForm = ({ setOpen }) => {
  const [authToken, setAuthToken] = useState("");
  const { getAccessTokenSilently } = useAuth0();
  const { operationLogs } = useAppContextProvider();
  const { colors } = useTheme();

  const closeDialog = async (data) => {
    setOpen(false);
  };

  const columns = [
    {
      field: "severity",
      headerName: "Severity",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "message",
      headerName: "Message",
      flex: 1,
      minWidth: 100,
    },
  ]

  const operationLogsModified = operationLogs.map((log, index) => ({
    id: index + 1,
    severity: log.severity,
    message: log.message,
  }));

  const dataGridProps = {
    rows: operationLogsModified || [],
    columns: columns,
    hideFooter: true,
    getRowId: (row) => row.id,
    getRowHeight: () => 'auto',

  };

  React.useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await getAccessTokenSilently();
        setAuthToken(token);
      } catch (error) {
        console.error(" Error fetching token:", error);
      }
    };
    fetchToken();
  }, [getAccessTokenSilently]);

  return (
    <>
      <OperationLogsHeader setOpen={setOpen} />

      <Box
        display={"flex"}
        flexGrow={1}
        overflow={'auto'}
        height={"auto"}
      >
        {operationLogs.length > 0 && columns.length > 0 && <StyledDataGrid colors={colors} {...dataGridProps} sx={{
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            display: 'flex',
            alignItems: 'flex-start',
          },
        }}/>}
      </Box>
    </>
  );
};

const OperationLogsDialog = ({ open, setOpen }) => {
  const { colors } = useTheme();
  return (
    <StyledDialog
      colors={colors}
      maxWidth={"md"}
      fullWidth
      open={open}
      hideBackdrop
    >
      <DialogContent sx={{ padding: 0 }}>
        <OperationLogsForm setOpen={setOpen} />
      </DialogContent>
    </StyledDialog>
  );
};

export default OperationLogsDialog;
